import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideUserX = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx={9} cy={7} r={4} />
      <path d="m17 8 5 5m0-5-5 5" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideUserX);
const Memo = memo(ForwardRef);
export default Memo;
